import React, { useState, useEffect } from "react";
import { func, bool, string, object } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import Headline from "../../atoms/Headline";
import HeaderWrapper from "../../header/header-wrapper";
import Stories2AdWithLoadMore from "../../rows/Stories2AdWithLoadMore";
import WithSSO from "../../with-sso";

import { staticTexts } from "../../utils/Translate";

import { setLoading } from "../../helper/actions";
import { getBookmarkStories, getUser } from "../../helper/api";

import "./saved-story-view.m.css";

const SavedStoryView = ({
  setLoading,
  isLoading,
  jwtToken,
  metypeConfig,
  currentPath,
  sketchesHost,
  authHost,
  publisherAttributes
}) => {
  const [stories, setStories] = useState([]);
  const [member, setMember] = useState(null);
  const [isMoreStoriesAvailable, setIsMoreStoriesAvailable] = useState(true);
  const redirectUrl = `${sketchesHost}${currentPath}`;
  const callbackUrl = sketchesHost;
  const notLoggedInView = () => (
    <div styleName="not-logged-view">
      <WithSSO ssoHost={authHost} signInPath="/sign-in-page" redirectUrl={redirectUrl} callbackUrl={callbackUrl}>
        {({ signInHref }) => (
          <a styleName="button" href={signInHref}>
            Click here to login
          </a>
        )}
      </WithSSO>
    </div>
  );

  useEffect(() => {
    getUser().then(resp => setMember(resp));
    jwtToken && getStories();
  }, [jwtToken]);

  const getStories = () => {
    setLoading(true);

    getBookmarkStories(metypeConfig, jwtToken)
      .then(storyList => {
        if (storyList.length) {
          const newList = [...stories, ...storyList];

          setStories(newList);
          stories.length < 50 && setIsMoreStoriesAvailable(false);
        } else {
          setIsMoreStoriesAvailable(false);
        }
      })
      .finally(() => setLoading(false));
  };

  return (
    <React.Fragment>
      <HeaderWrapper hideTopAd={true} />
      {member ? (
        <div styleName="top-container">
          <div styleName="content">
            <div styleName="title-details">
              <Headline
                text={staticTexts(publisherAttributes.lang).savedPageTitle}
                headerLevel={3}
                headlineType={9}
                styleName="title"
              />
              <Headline
                text={staticTexts(publisherAttributes.lang).savedPageSubTitle}
                headerLevel={3}
                headlineType={6}
                styleName="sub-title"
              />
            </div>
          </div>

          <Stories2AdWithLoadMore
            list={stories}
            loading={isLoading}
            onLoadMore={getStories}
            isMoreStories={isMoreStoriesAvailable}
          />
        </div>
      ) : (
        notLoggedInView()
      )}
    </React.Fragment>
  );
};

SavedStoryView.propTypes = {
  setLoading: func,
  isLoading: bool,
  jwtToken: string,
  metypeConfig: object,
  member: object,
  currentPath: string,
  sketchesHost: string,
  authHost: string,
  publisherAttributes: object
};

const mapStateToProps = state => ({
  isLoading: get(state, ["pageLoading"], false),
  jwtToken: get(state, ["userReducer", "jwt_token"], null),
  authHost: get(state, ["qt", "config", "publisher-attributes", "auth_host"], null),
  metypeConfig: get(state, ["qt", "config", "publisher-attributes", "metypeConfig"], {}),
  sketchesHost: get(state, ["qt", "config", "sketches-host"], "https://www.prothomalo.com"),
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {})
});

const mapDispatchToProps = dispatch => ({
  setLoading: isLoading => dispatch(setLoading(isLoading))
});

export default connect(mapStateToProps, mapDispatchToProps)(SavedStoryView);
